import { requestConstantsMaker } from '../helper';

export const GET_ALL_INVOICE = requestConstantsMaker('GET_ALL_INVOICE');
export const GET_INVOICE = requestConstantsMaker('GET_INVOICE');
export const GET_INVOICE_BY_HASH_INVOICE_NUMBER = requestConstantsMaker('GET_INVOICE_BY_HASH_INVOICE_NUMBER');
export const POST_CREATE_INVOICE = requestConstantsMaker('POST_CREATE_INVOICE');
